export default class Social {
    newWindow(url) {
        // eslint-disable-next-line no-unused-vars
        const $this = this;
        const left = (window.screen.width - 570) / 2;
        const top = (window.screen.height - 570) / 2;
        const params = `menubar=no,toolbar=no,status=no,width=570,height=570,top=${top},left=${left}`;
        window.open(url, 'NewWindow', params);
    }
}
